import { BaseRouteService } from "core/services";

class WoundRouteService extends BaseRouteService {
    constructor() {
        super("wounds");
    }

    find(filter) {
        return super.find(
            this.base +
                "/{?searchQuery,page,rpp,sort,embed,fields,woundOrderId}",
            filter
        );
    }

    get(id, options) {
        return super.get(this.base + "/{id}/{?embed,fields}", id, options);
    }

    downloadReport(woundOrderId) {
        return super.get(this.base + "/download{?woundOrderId}", null, {
            woundOrderId: woundOrderId
        });
    }

    update(resource) {
        return super.update(this.base + "/{id}", resource);
    }

    delete(id) {
        return super.delete(this.base + "/{id}", id);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    validateDispensingOrder(resource) {
        return super.create(this.base + "/validate-dispensing-order", resource);
    }

    getWoundCalculations(resource) {
        return super.create(this.base + "/calculate-wound-results", resource);
    }

    checkDressingCombinations(resource) {
        return super.create(this.base + "/check-dressing-combinations", resource);
    }

    submitDressingCombinations(resource) {
        return super.create(this.base + "/submit-dressing-combinations", resource);
    }

    calculateDispensingOrder(resource) {
        return super.create(this.base + "/calculate-dispensing-result", resource);
    }
}

export default WoundRouteService;
